import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthStore } from '@hooks/useAuthStore'

export function ProtectedRoute() {
  const { isAuthenticated, activeClinicId, clinicsList } = useAuthStore()
  const location = useLocation()

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  // Multi-clinic users without an active clinic must select one first
  if (
    !activeClinicId &&
    clinicsList.length > 1 &&
    location.pathname !== '/select-clinic'
  ) {
    return <Navigate to="/select-clinic" replace />
  }

  return <Outlet />
}
